import { h, Component } from 'preact';

import Form from '../../components/form';
import FormStructure from '../../../client_forms/includes';

import FieldTypeRenderer from './field_type_renderer';

import './index.css';

export default class App extends Component {
	state = { formStructure: FormStructure };

	render() {
		return (
			<div id="app">
				<Form formStructure={this.state.formStructure} fieldTypeRenderer={new FieldTypeRenderer()} />
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./index.js